import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

import {
  withFormik
} from 'formik';

import {
  BulmaSection
} from '../../components/HelperComponents/HelperComponents';

import {
  ProfileLabel,
  PrimaryButton,
  InputBlack,
  VerticalForm,
  SecondaryButton
} from '../../components/HelperComponents/StyledComponents';

import PropTypes from 'prop-types';

import {
  getProfileInformation,
  updateProfileInformation
} from '../../actions/UserActions';

// Our inner form component which receives our form's state and updater methods as props
const InnerForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
}) => (
  <Fragment>
    <form onSubmit={handleSubmit} style={{ marginTop: '1rem' }} className="columns is-multiline">
      <VerticalForm className="column">
        <div className="field">
          <div className="control">
            <ProfileLabel className="label has-text-white">First Name</ProfileLabel>
            <InputBlack
              className="input is-rounded"
              type="text"
              name="first_name"
              placeholder="First Name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.first_name}
            />
            {touched.first_name && errors.first_name && <div>{errors.first_name}</div>}
          </div>
        </div>

        <div className="field">
          <div className="control">
            <ProfileLabel className="label has-text-white">Last Name</ProfileLabel>
            <InputBlack
              className="input is-rounded"
              type="text"
              name="last_name"
              placeholder="Last Name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.last_name}
            />
            {touched.last_name && errors.last_name && <div>{errors.last_name}</div>}
          </div>
        </div>

        <div className="field">
          <div className="control" >
            <ProfileLabel className="label has-text-white">Email</ProfileLabel>
            <InputBlack
              className="input is-rounded"
              placeholder="Email"
              type="email"
              name="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
            />
            {touched.email && errors.email && <div>{errors.email}</div>}
          </div>
        </div>


        <div className="field">
          <div className="control" >
            <ProfileLabel className="label has-text-white">Birth Date</ProfileLabel>
            <InputBlack
              className="input is-rounded"
              placeholder="Birth Date"
              type="date"
              name="birth_date"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.birth_date}
            />
            {touched.birth_date && errors.birth_date && <div>{errors.birth_date}</div>}
          </div>
        </div>

        <div className="field">
          <div className="control">
            <ProfileLabel className="label has-text-white">Company</ProfileLabel>
            <InputBlack
              className="input is-rounded"
              placeholder="Company"
              type="text"
              name="company"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.company}
            />
            {touched.company && errors.company && <div>{errors.company}</div>}
          </div>
        </div>


        <div className="field">
          <div className="control">
            <ProfileLabel className="label has-text-white">Position</ProfileLabel>
            <InputBlack
              className="input is-rounded"
              type="text"
              name="position"
              placeholder="Position"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.position}
            />
            {touched.position && errors.position && <div>{errors.position}</div>}
          </div>
        </div>

        <div className="field">
          <div className="control" >
            <ProfileLabel className="label has-text-white">Country</ProfileLabel>
            <InputBlack
              className="input is-rounded"
              placeholder="Country"
              type="text"
              name="country"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.country}
            />
            {touched.country && errors.country && <div>{errors.country}</div>}
          </div>
        </div>

        <div className="field">
          <div className="control" >
            <ProfileLabel className="label has-text-white">Postal Code</ProfileLabel>
            <InputBlack
              className="input is-rounded"
              placeholder="Postal Code"
              type="text"
              name="postcode"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.postcode}
            />
            {touched.postcode && errors.postcode && <div>{errors.postcode}</div>}
          </div>
        </div>

        <div className="field">
          <div className="control" >
            <ProfileLabel className="label has-text-white">Address</ProfileLabel>
            <InputBlack
              className="input is-rounded"
              placeholder="Address"
              type="text"
              name="address"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.address}
            />
            {touched.address && errors.address && <div>{errors.address}</div>}
          </div>
        </div>
      </VerticalForm>
      <section className="column is-full">
        <section className="field is-grouped is-grouped-right">
          <div className="control">
            <Link to="/profile" className="has-text-white">
              <SecondaryButton className="button is-rounded is-dark" type="button">
                Cancel
              </SecondaryButton>
            </Link>
            <PrimaryButton className="button is-rounded" type="submit" disabled={isSubmitting}>
              Save
            </PrimaryButton>
          </div>
        </section>
      </section>

    </form>
  </Fragment>
);



InnerForm.propTypes = {
  values: PropTypes.any,
  errors: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
  touched: PropTypes.any,
  isSubmitting: PropTypes.any
};

export class ProfileEditComponent extends Component {

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    dispatch: PropTypes.func
  }

  componentDidMount() {
    this.props.dispatch(getProfileInformation(this.props.user.data.token));
  }

  render() {
    const user = this.props.user;

    const MyForm = withFormik({
      mapPropsToValues: _props => ({
        username: user.data.username,
        email: user.data.email,
        first_name: user.data.first_name,
        last_name: user.data.last_name,
        birth_date: user.data.birth_date,
        company: user.data.company,
        position: user.data.position,
        address: user.data.address,
        postcode: user.data.postcode,
        country: user.data.country
      }),
      // Add a custom validation function (this can be async too!)
      validate: (values, _props) => {
        const errors = {};
        if (!values.email) {
          errors.email = 'Required';
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
        ) {
          errors.email = 'Invalid email address';
        }
        return errors;
      },
      // Submission handler
      handleSubmit: (
        values,
        {
          _props,
          _setSubmitting,
          _setErrors /* setValues, setStatus, and other goodies */,
        }
      ) => {
        this.props.dispatch(updateProfileInformation(this.props.user.data.token, values, this.props.history));
      },
    })(InnerForm);

    return (
      <BulmaSection columnsClassName="is-centered">
        <section className="column is-8">
          <MyForm />
        </section>
      </BulmaSection>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;

  return {
    user
  };
}


export const ProfileEdit = connect(mapStateToProps)(ProfileEditComponent);


// WEBPACK FOOTER //
// ./src/routes/ProfileEdit/ProfileEdit.js